import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'

import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import type { SupervisorPendingRequestsParams } from '@/utils/api/leave-service/models'

import { supervisorPendingRequests } from '@/utils/api/leave-service'

export const SUPERVISOR_ACCESS_HEADER = 'x-skip-access-toast' as const

const SUPERVISOR_ACCESS_QUERY_KEY = ['supervisor-access'] as const
const SUPERVISOR_PENDING_PARAMS: SupervisorPendingRequestsParams = {
  pageable: { page: 0, size: 1 },
}

const SUPERVISOR_ACCESS_CONFIG: AxiosRequestConfig = {
  headers: { [SUPERVISOR_ACCESS_HEADER]: 'true' },
}

export async function checkSupervisorAccess(): Promise<boolean> {
  try {
    await supervisorPendingRequests(SUPERVISOR_PENDING_PARAMS, SUPERVISOR_ACCESS_CONFIG)
    return true
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status
      if (status === 401 || status === 403) {
        return false
      }
    }
    throw error
  }
}

export function useSupervisorAccess(
  options?: UseQueryOptions<boolean, AxiosError<unknown>, boolean>,
): UseQueryResult<boolean, AxiosError<unknown>> {
  return useQuery({
    queryKey: SUPERVISOR_ACCESS_QUERY_KEY,
    queryFn: checkSupervisorAccess,
    staleTime: 1000 * 60 * 5,
    retry: false,
    ...options,
  })
}
